import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { rememberReturnPath } from '@/lib/return-path'
import { Skeleton } from '@/components/ui/skeleton'

function AuthLoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="space-y-3 w-48">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  )
}

export function AuthGuard() {
  const { fridayToken, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) return <AuthLoadingScreen />
  if (!fridayToken) {
    // Router state alone is not enough. Signing in is a full-page MSAL redirect out to
    // Microsoft and back, which destroys it, so the intended page is also written
    // somewhere that survives the round trip. See lib/return-path.ts.
    rememberReturnPath(location)
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  return <Outlet />
}
